export const FETCH_RETURNSGRID_DATA_BEGIN="FETCH_RETURNSGRID_DATA_BEGIN";
export const FETCH_RETURNSGRID_DATA_SUCCESS="FETCH_RETURNSGRID_DATA_SUCCESS";
export const FETCH_RETURNSGRID_DATA_FAILURE="FETCH_RETURNSGRID_DATA_FAILURE";

export const FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN="FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN";
export const FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS="FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS";
export const FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE="FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE";

export const FETCH_TRAILINGPERFORMANCE_DATA_BEGIN="FETCH_TRAILINGPERFORMANCE_DATA_BEGIN";
export const FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS="FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS";
export const FETCH_TRAILINGPERFORMANCE_DATA_FAILURE="FETCH_TRAILINGPERFORMANCE_DATA_FAILURE";

export const FETCH_VSBMCALYRS_DATA_BEGIN="FETCH_VSBMCALYRS_DATA_BEGIN";
export const FETCH_VSBMCALYRS_DATA_SUCCESS="FETCH_VSBMCALYRS_DATA_SUCCESS";
export const FETCH_VSBMCALYRS_DATA_FAILURE="  FETCH_VSBMCALYRS_DATA_FAILURE";

export const FETCH_STATSUMMARY_DATA_BEGIN="FETCH_STATSUMMARY_DATA_BEGIN";
export const FETCH_STATSUMMARY_DATA_SUCCESS="FETCH_STATSUMMARY_DATA_SUCCESS";
export const FETCH_STATSUMMARY_DATA_FAILURE="FETCH_STATSUMMARY_DATA_FAILURE";

export const FETCH_BMSTATSUMMARYROR_DATA_SUCCESS="FETCH_BMSTATSUMMARYROR_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS="FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS="FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS="FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS="FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS="FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS="FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS="FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYALPHA_DATA_BEGIN="FETCH_BMSTATSUMMARYALPHA_DATA_BEGIN";
export const FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS="FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS="FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS="FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS";
export const FETCH_BMSTATSUMMARY_DATA_FAILURE="  FETCH_BMSTATSUMMARY_DATA_FAILURE";

export const FETCH_BMDDHistory_DATA_BEGIN="FETCH_BMDDHistory_DATA_BEGIN";
export const FETCH_BMDDHistory_DATA_SUCCESS="FETCH_BMDDHistory_DATA_SUCCESS";
export const FETCH_BMDDHistory_DATA_FAILURE="FETCH_BMDDHistory_DATA_FAILURE";

//return and statics chart constants
export const FETCH_VAMICHART_DATA_BEGIN='FETCH_VAMICHART_DATA_BEGIN';
export const FETCH_VAMICHART_DATA_SUCCESS='FETCH_VAMICHART_DATA_SUCCESS';
export const FETCH_VAMICHART_DATA_FAILURE='FETCH_VAMICHART_DATA_FAILURE';

export const FETCH_DISTRCHART_DATA_BEGIN='FETCH_DISTRCHART_DATA_BEGIN';
export const FETCH_DISTRCHART_DATA_SUCCESS='FETCH_DISTRCHART_DATA_SUCCESS';
export const FETCH_DISTRCHART_DATA_FAILURE='FETCH_DISTRCHART_DATA_FAILURE';

export const FETCH_ROLLINGCHART_DATA_BEGIN='FETCH_ROLLINGCHART_DATA_BEGIN';
export const FETCH_ROLLINGCHART_DATA_SUCCESS='FETCH_ROLLINGCHART_DATA_SUCCESS';
export const FETCH_ROLLINGCHART_DATA_FAILURE='FETCH_ROLLINGCHART_DATA_FAILURE'; 

export const FETCH_CUMMCHART_DATA_BEGIN='FETCH_CUMMCHART_DATA_BEGIN';
export const FETCH_CUMMCHART_DATA_SUCCESS='FETCH_CUMMCHART_DATA_SUCCESS';
export const FETCH_CUMMCHART_DATA_FAILURE='FETCH_CUMMCHART_DATA_FAILURE';


